module.exports = __webpack_public_path__ + "media/country_flags/uz-3fc5861d.png";